import React, { useState } from 'react';
import { TextField, Button, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckboxList from './CheckboxList';


function convertToObjects(productIds) {
    return productIds.map(productId => ({ productId }));
}

const Form = ({ formData, fetchData, handleClose, handleFetchSuccess, handleFetchFailure }) => {
  const navigate = useNavigate();

  const [data, setData] = useState({
    name: formData.name,
    _id: formData._id,
  });

  const [ProductwithId, setProductwithId] = useState([])

  const [selectedIds, setSelectedIds] = useState([]);
  const [checkboxData, setCheckboxData] = useState([]);
  const [editMode, setEditMode] = useState(false);

  const handleEdit = async () => {
    const userDetails = JSON.parse(localStorage.getItem('token'));
    let token = userDetails ? userDetails.result.token : null;

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/products/completelist`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        alert('Session Expired, Please login again');
        localStorage.removeItem('token');
        navigate('/login');
      }
      if (!response.ok) {
        handleFetchFailure();
        throw new Error('Network response was not ok');
      } else {
        const jsonData = await response.json();
        console.log('data from copied status', jsonData);
        setCheckboxData(jsonData);
        setProductwithId(jsonData)
        setSelectedIds(jsonData.map(item => item._id));
        console.log("ProductwithId", jsonData.map(item => item._id))
      }
    } catch (error) {
      console.error('Error submitting form data:', error);
    }
    setEditMode(true);
  };

  const handleDelete = async () => {
    const userDetails = JSON.parse(localStorage.getItem('token'));
    let token = userDetails ? userDetails.result.token : null;

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/campaigns/${data._id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 401) {
        alert('Session Expired, Please login again');
        localStorage.removeItem('token');
        navigate('/login');
      }
      if (!response.ok) {
        handleFetchFailure();
        throw new Error('Network response was not ok');
      } else {
        handleFetchSuccess();
        fetchData();
        handleClose();
      }
    } catch (error) {
      console.error('Error deleting data:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    const userDetails = JSON.parse(localStorage.getItem('token'));
    let token = userDetails ? userDetails.result.token : null;

    e.preventDefault();
    try {
    // console.log("Put")
    //   const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/campaigns/${data._id}`, {
    //     method: 'PUT',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       Authorization: `Bearer ${token}`,
    //     },
    //     body: JSON.stringify(data),
    //   });
    //   console.log(data)
    console.log("About to Put id", data._id)
    console.log("selectedIds = ", selectedIds)
      const response2 = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/campaigns/${data._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          "name": data.name,
          "isActive": true,
          "products": convertToObjects(selectedIds)
        })
      });

      if (response2.status === 401) {
        alert('Session Expired, Please login again');
        localStorage.removeItem('token');
        navigate('/login');
      }
      if (!response2.ok) {
        handleFetchFailure();
        throw new Error('Network response was not ok');
      }
      handleFetchSuccess();
      handleClose();
      setEditMode(false);
      fetchData();
    } catch (error) {
      console.error('Error submitting form data:', error);
      handleFetchFailure();
      handleClose();
    }
  };

  return (
    <Grid container justifyContent="center" style={{ height: '80vh', alignItems: 'center' }}>
      <Grid item xs={12} md={10} lg={8}>
        <Paper elevation={3} style={{ padding: '20px', height: '100%', width: '100%', overflowY: 'auto' }}>
          {editMode ? (
            <form onSubmit={handleSubmit}>
              <div className='flex gap-3'>
                <div className='flex-1'>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Campaign Name"
                    id="name"
                    name="name"
                    value={data.name}
                    onChange={handleChange}
                    disabled
                  />
                </div>
                <div className='flex-1'>
                  {checkboxData && <CheckboxList selectedIds={selectedIds} setSelectedIds={setSelectedIds} data={checkboxData} />}
                </div>
              </div>
              <div style={{ marginTop: '20px', textAlign: 'match-parent' }}>
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: '20px',
                    backgroundColor: 'green',
                    '&:hover': {
                      backgroundColor: 'blue',
                    },
                  }}
                  type="submit"
                >
                  Submit
                </Button>
              </div>
            </form>
          ) : (
            <div>
              <TextField
                fullWidth
                margin="normal"
                label="Campaign"
                value={data.name}
                InputProps={{ readOnly: true }}
              />
              <div className='flex justify-between'>
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: '20px',
                    backgroundColor: 'green',
                    '&:hover': {
                      backgroundColor: 'blue',
                    },
                  }}
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: '20px',
                    backgroundColor: 'green',
                    '&:hover': {
                      backgroundColor: 'blue',
                    },
                  }}
                  onClick={handleDelete}
                >
                  Delete
                </Button>
              </div>
            </div>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Form;
